import { render, staticRenderFns } from "./addCopy.vue?vue&type=template&id=5793975f&scoped=true&name=addCopy&"
import script from "./addCopy.vue?vue&type=script&lang=js&"
export * from "./addCopy.vue?vue&type=script&lang=js&"
import style0 from "./addCopy.vue?vue&type=style&index=0&id=5793975f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5793975f",
  null
  
)

export default component.exports